<script setup lang="ts">
import type { TwoColumnBlock } from '~/types/storyblok/two-column-block'

interface Props {
  blok: TwoColumnBlock
}

const props = defineProps<Props>()
const blok = toRef(props, 'blok')
const firstComponent = computed(() => blok.value.blocks[0])
const secondComponent = computed(() => blok.value.blocks[1])
</script>

<template>
  <div
    v-if="blok"
    class="two-column"
  >
    <component
      :is="firstComponent.component"
      :blok="firstComponent"
      class="component"
    />
    <component
      :is="secondComponent.component"
      :blok="secondComponent"
      class="component"
    />
  </div>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.two-column {
  display: flex;
  flex-direction: column;

  @media(min-width: $large-breakpoint) {
    flex-direction: row;
  }
}

.component {
  width: 100%;
  @media(min-width: $large-breakpoint) {
    width: 50%;
  }
}
</style>
